import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/navbar.css';
import dolLogo from '../pics/dofcan-logo.png';

const navItems = [
  { label: 'Home', route: '/' },
  { label: 'Verify Certificate', route: '/verify' },
  { label: 'Gallery', route: '/gallery' },
  { label: 'About', route: '/about' },
  { label: 'Services', route: '/services' },
  { label: 'Training & Certification', route: '/training-certification' },
  { label: 'Contact', route: '/contact' }
];

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavigate = (route) => {
    navigate(route);
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand" onClick={() => handleNavigate('/')}>
          <img src={dolLogo} alt="Dofcan Oilserve logo" className="navbar-logo-image" />
        </div>

        <button
          type="button"
          className={`navbar-toggle ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>

        <ul className={`navbar-nav ${menuOpen ? 'open' : ''}`}>
          {navItems.map((item) => (
            <li key={item.route}>
              <button type="button" className="navbar-link" onClick={() => handleNavigate(item.route)}>
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
